import exchangeReducer from './reducer';
import * as exchangeActions from './actions';

export const reducer = exchangeReducer;
export const actions = exchangeActions;
